import { tw } from '@/utils/tw';
import { ButtonTheme } from '@/components/Button/theme';

const Button = tw.theme({
  extend: ButtonTheme,
  base: ['self-center', 'relative'],
});

const FrisbiiPayment = tw.theme({
  slots: {
    base: [],
    content: ['flex', 'flex-col'],
    caption: ['mt-3', 'flex', 'items-center', 'justify-center', 'gap-2'],
  },
});

export default Object.assign(FrisbiiPayment, { Button });
